import React from 'react';
import { Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const pageLinks = [
  { key: 'wholesale', title: 'WHOLESALE', subtitle: 'Bulk Orders',      route: '/products/wholesale', image: '/img/31.jpg' },
  { key: 'retail',    title: 'RETAIL',    subtitle: 'Packaged Products', route: '/products/retail',    image: '/img/32.jpg' },
  { key: 'tea',       title: 'TEA',       subtitle: 'Tea Collection',    route: '/products/tea',       image: '/img/33.jpg' },
];

const ProductsPage = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        position: 'relative',
        backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.54), rgba(0, 0, 0, 0.35)), url(/img/23.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: { xs: 'scroll', md: 'fixed' },
      }}
    >
      <Box sx={{ position: 'relative', zIndex: 1, minHeight: '100vh' }}>
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <Box
            sx={{
              minHeight: '100vh',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              px: { xs: 4, md: 8 },
              py: { xs: 8, md: 10 },
            }}
          >
            <Box sx={{ textAlign: 'center', width: '100%' }}>
              <Box sx={{ display: 'flex', justifyContent: { xs: 'flex-start', md: 'flex-end' }, mb: 4 }}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: { xs: 1, md: 2 },
                    cursor: 'pointer',
                    width: 'fit-content',
                    backgroundColor: 'rgba(216, 216, 188, 0.8)',
                    backdropFilter: 'blur(8px)',
                    px: { xs: 1.5, md: 2 },
                    py: { xs: 0.8, md: 1 },
                    borderRadius: '8px',
                  }}
                  onClick={() => navigate('/')}
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="#1A1A1A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <Typography sx={{ fontFamily: 'Roboto', fontSize: { xs: '14px', md: '16px' }, fontWeight: 500, color: '#1A1A1A', whiteSpace: 'nowrap' }}>
                    Back to Home
                  </Typography>
                </Box>
              </Box>

              <Typography
                sx={{
                  fontFamily: 'Oswald',
                  fontSize: { xs: '48px', sm: '64px', md: '80px', lg: '96px' },
                  fontWeight: 700,
                  color: '#FFFFFF',
                  letterSpacing: '0.05em',
                  lineHeight: 0.9,
                  mb: 1,
                }}
              >
                OUR
              </Typography>

              <Typography
                sx={{
                  fontFamily: 'Oswald',
                  fontSize: { xs: '48px', sm: '64px', md: '80px', lg: '96px' },
                  fontWeight: 700,
                  color: '#2858A8',
                  letterSpacing: '0.05em',
                  lineHeight: 0.9,
                  mb: 6,
                }}
              >
                PRODUCTS
              </Typography>

              {/* <Typography
                sx={{
                  fontFamily: 'Roboto',
                  fontSize: { xs: '16px', md: '18px' },
                  fontWeight: 400,
                  color: '#1A1A1A',
                  lineHeight: 1.8,
                  mb: 8,
                }}
              >
                Choose the page you want to explore
              </Typography> */}

              <Box
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', md: 'row' },
                  gap: 4,
                  justifyContent: 'center',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                }}
              >
                {pageLinks.map((link) => (
                  <motion.div key={link.key} whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                    <Box
                      onClick={() => navigate(link.route)}
                      sx={{
                        width: { xs: '280px', md: '320px' },
                        height: { xs: '200px', md: '240px' },
                        backgroundImage: `linear-gradient(rgba(8, 8, 8, 0.68), rgba(8, 8, 8, 0.69)), url(${link.image})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        borderRadius: '12px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        border: '3px solid #979797a0',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          border: '3px solid #2858A8',
                          boxShadow: '0 8px 30px rgba(40, 88, 168, 0.3)',
                          backgroundImage: `linear-gradient(rgba(8,8,8,0.35), rgba(8,8,8,0.35)), url(${link.image})`,
                          backgroundSize: 'cover',
                          backgroundPosition: 'center',
                        },
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: 'Oswald',
                          fontSize: { xs: '28px', md: '32px' },
                          fontWeight: 600,
                          color: '#FFFFFF',
                          letterSpacing: '0.05em',
                        }}
                      >
                        {link.title}
                      </Typography>
                      <Typography sx={{ fontFamily: 'Roboto', fontSize: '14px', fontWeight: 300, color: '#D4C5B0', mt: 1 }}>
                        {link.subtitle}
                      </Typography>
                    </Box>
                  </motion.div>
                ))}
              </Box>
            </Box>
          </Box>
        </motion.div>
      </Box>
    </Box>
  );
};

export default ProductsPage;
